import { Box, Typography } from '@mui/material';
import { NormalButton } from 'components/atoms/Button';
import CoinButton from 'components/atoms/CoinButton';
import React from 'react';
import BasicModal from '../Modal';
const ethIcon = require('assets/ethereum-eth-logo.png');
const tethIcon = require('assets/tether-usdt-logo.png');
const usdIcon = require('assets/usd-coin-usdc-logo.png');
const shibaIcon = require('assets/shiba-inu-shib-logo.png');
const busdIcon = require('assets/binance-usd-busd-logo.png');
const bnbIcon = require('assets/bnb-bnb-logo.png');

interface ICoinsModalProps {
  children: JSX.Element;
}

const CoinsModal: React.FC<ICoinsModalProps> = ({ children }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <div>
      <span onClick={handleOpen}>{children}</span>

      <BasicModal open={open} handleClose={handleClose}>
        <>
          <img alt="" />
          <Typography
            sx={{ textAlign: 'center', color: 'white' }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Select Types Of Cryptos To Accept
          </Typography>

          <Typography
            id="modal-modal-description"
            sx={{ my: 4, textAlign: 'center', opacity: '0.6' }}
          >
            Note: each crypto has different fees to consider.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '15px',
              justifyContent: 'center',
            }}
          >
            <CoinButton img={ethIcon} text={'ETH'} />
            <CoinButton img={tethIcon} text={'Tether USD'} />
            <CoinButton img={usdIcon} text={'USD Coin'} />
            <CoinButton img={shibaIcon} text={'Shiba Inu'} />
            <CoinButton img={busdIcon} text={'BUSD'} />
            <CoinButton img={bnbIcon} text={'BNB'} />
          </Box>
          <NormalButton
            text={'Confirm'}
            color="yellow"
            sx={{
              width: '100%',
              textTransform: 'uppercase',
              marginTop: '50px',
            }}
          />
        </>
      </BasicModal>
    </div>
  );
};

export default CoinsModal;
